import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const ROOT_FOLDER_ID = 0;

const FetchRootFolderQuery = gql`
  query FetchRootFolder {
    workflowFolder {
      id
    }
  }
`;

/**
 * This is temporary until we can get this off project settings
 * https://iterable.slab.com/posts/7-1-21-treating-null-as-folder-id-for-root-folders-8tre2dp6#proposed-options
 */
export function useRootFolderId(): number {
  const { data } = useGraphql(FetchRootFolderQuery);
  return data?.workflowFolder?.id || ROOT_FOLDER_ID;
}
